const parseDataBeforeSending = (data = {}) =>
  Object.keys(data).reduce((obj, key) => {
    const value = data[key];

    if (typeof value === "string") {
      return {
        ...obj,
        [key]: value.trim(),
      };
    }

    return {
      ...obj,
      [key]: value,
    };
  }, {});

export default parseDataBeforeSending;
